import React, { Component } from "react";
import { connect } from "react-redux";

import { SelectItem } from "app/NativeComponents/snippets";

import {
  bulkUpdateLeads,
  setTagModal,
  pushSidePanel,
  numberWithCommas
} from "app/NativeActions";
class RemoveTagsButton extends Component {
  render() {
    const { button_search, title, selected_all, selected_leads } = this.props;
    const { token, user, filtered_count } = this.props;

    if (
      !button_search ||
      title.toLowerCase().includes(button_search.toLowerCase())
    ) {
      return (
        <SelectItem
          select_type="none"
          icon="keyboard-arrow-right"
          onPress={() => {
            this.props.setTagModal({
              title: "Remove tag(s) from leads",
              description: selected_all
                ? "Choose a tag or mulitple tags to remove from all " +
                  filtered_count +
                  " leads."
                : selected_leads.length === 1
                ? "Choose a tag or mulitple tags to remove from " +
                  selected_leads[0].property_address +
                  "."
                : "Choose a tag or mulitple tags to remove from your selected " +
                  selected_leads.length +
                  " leads.",
              type: "remove_tags_from_leads",
              selected_leads: selected_all ? "all" : selected_leads,
              selected_tags: [],
              modalAction: ({
                selected_leads,
                selected_tags,
                onLoading = () => {},
                onError = () => {},
                onSuccess = () => {}
              }) => {
                onLoading();
                this.props.bulkUpdateLeads({
                  token: token,
                  type: "remove_tags_from_leads",
                  tag_ids: selected_tags
                    .map(tag => {
                      return tag.id;
                    })
                    .join(),
                  select_all: selected_all ? 1 : 0,
                  filters:
                    this.props.applied_filter &&
                    this.props.applied_filter.filters
                      ? this.props.applied_filter?.filters
                      : null,
                  property_flags: this.props.lead_filters?.property_flags
                    .map(({ value }) => value)
                    .join(","),
                  property_flags_and_or:
                    this.props.lead_filters?.property_flags_and_or,
                  search: this.props.search,
                  search_type: this.props.search_type,
                  list_id: this.props.active_list_tab?.id
                    ? this.props.active_list_tab?.id
                    : this.props.active_list_tab,
                  total_count: selected_all
                    ? filtered_count
                    : selected_leads.length,
                  lead_ids: selected_all
                    ? ""
                    : selected_leads
                        .map(property => {
                          return property.deal.id;
                        })
                        .join(),
                  onLoading: () => {
                    onLoading();
                  },
                  onError: () => {
                    onError();
                  },
                  onSuccess: () => {
                    onSuccess();
                    this.props.clearAll();
                  }
                });
              }
            });

            this.props.pushSidePanel({ slug: "tags", overlay: true });
            this.props.toggleMenu(false);
          }}
        >
          {title}
        </SelectItem>
      );
    }
    return null;
  }
}

const mapStateToProps = ({ auth }) => {
  const { token, user } = auth;
  return {
    token,
    user
  };
};

export default connect(mapStateToProps, {
  bulkUpdateLeads,
  setTagModal,
  pushSidePanel
})(RemoveTagsButton);
